import component from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-employer/lni-retaliation-employer.component.vue';
import module from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-employer/lni-retaliation-employer.module.js';

export default {
    component,
    module,
};